<section id="wrapper" class="login-register login-center login-sidebar" 
style="background-image:url(assets/images/background/apsgapclaims.jpg);">
  <div class="login-box card">
    <div class="card-header p-0">
      <a href="javascript:void(0)" class="text-center db logo-container">
        {{appname}} Claims
      </a>
    </div>
    <div class="card-body" *ngIf="resetPasswordForm">
      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="execute()"
        class="form-horizontal form-material"
        id="resetPasswordForm"
        novalidate
      >
        <h3 class="box-title m-b-1">Reset password</h3>
        <app-missed-errors></app-missed-errors>
        <div class="form-group">
          <div class="col-xs-12">
            <app-form-error-wrapper
              [apiErrorType]="'password'"
              [control]="resetPasswordForm.controls['password']"
              [controlName]="'Password'"
              [apiErrorType]="'password'"
            >
            <div class="input-group input-group-merge form-password-toggle">
              <input
                class="form-control"
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                placeholder="New Password"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                (click)="passwordTextType = !passwordTextType;"
                  ><i
                    class="fa"
                    [ngClass]="{
                      'fa-eye-slash': passwordTextType,
                      'fa-eye': !passwordTextType
                    }"
                  ></i
                ></span>
              </div>
            </div>
            </app-form-error-wrapper>
            <span
            class="error help-block text-danger mt-1 d-block small"
            *ngIf="resetPasswordForm.get('password').value && resetPasswordForm.get('password').invalid"
            >Password must have minimum one Lowercase, Uppercase, Numbers, Special characters and 8 characters length
          </span>
          </div>
        </div>
        <div class="form-group">
          <div class="col-xs-12">
            <app-form-error-wrapper
              [apiErrorType]="'cPassword'"
              [control]="resetPasswordForm.controls['cPassword']"
              [controlName]="'Confirm Password'"
              [apiErrorType]="'cpassword'"
            >
            <div class="input-group input-group-merge form-password-toggle">
              <input
                class="form-control"
                [type]="cPasswordTextType ? 'text' : 'password'"
                formControlName="cPassword"
                placeholder="Confirm Password"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                (click)="cPasswordTextType = !cPasswordTextType;"
                  ><i
                    class="fa"
                    [ngClass]="{
                      'fa-eye-slash': cPasswordTextType,
                      'fa-eye': !cPasswordTextType
                    }"
                  ></i
                ></span>
              </div>
            </div>
            </app-form-error-wrapper>
            <span
              class="error help-block text-danger mt-1 d-block small"
              *ngIf="
                resetPasswordForm.get('cPassword').value &&
                resetPasswordForm.get('password').value !==
                  resetPasswordForm.get('cPassword').value
              "
              >Password doesn't matched.</span
            >
          </div>
        </div>
        <div class="form-group">
          <ngx-invisible-recaptcha #captchaElem
            [siteKey]="siteKey"
            (success)="handleSuccess($event)"
            [ngModel]="recaptcha"
            [ngModelOptions]="{ standalone: true }">
          </ngx-invisible-recaptcha>
        </div> 
        <div class="form-group text-center m-t-10 m-b-0">
          <div class="col-xs-12">
            <button
              class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
              [disabled]="resetPasswordForm.invalid || isLoading"
            >
              <app-button-loader
                [isLoading]="isLoading"
                [label]="'Reset password'"
              ></app-button-loader>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
